export enum OrderStatusEnum {
  GENERATED,
  PAID,
  CANCELLED,
  REFUND,
}
